import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Header from "../Header";
import { ShowStudentName, StudentAdmiration } from "../../api/aws-api";
import { ConstructorEventGet, ConstructorEventPost } from "../../Event/event";

const NotificationService = () => {
  const [studentName, setStudentName] = useState("");
  const [studentNameoptions, setStudentNameoptions] = useState([]);
  const [starRating, setStarRating] = useState(0);
  const navigate = useNavigate();

  useEffect(() => {
    ShowStudentNamelist();
  }, []);

  // const ShowStudentNamelist = async () => {
  //   try {
  //     // const responsedata = await ConstructorEventGet(ShowStudentName, {});
  //     const mentorId = JSON.parse(localStorage.getItem("UserKey"))["user_id"];

  //     const responsedata = await ConstructorEventGet(ShowStudentName, { mentorId });

  //     console.log("Full API Response:", responsedata);

  //     // 🔥 Parse body because Lambda returns string
  //     const parsedData = JSON.parse(responsedata.body);

  //     if (Array.isArray(parsedData)) {
  //       setStudentNameoptions(parsedData);
  //     } else {
  //       console.error("Parsed data is not array:", parsedData);
  //       setStudentNameoptions([]);
  //     }

  //   } catch (error) {
  //     console.error("Error fetching student names:", error);
  //   }
  // };

  const ShowStudentNamelist = async () => {
  try {
    const mentorId = JSON.parse(localStorage.getItem("UserKey"))["user_id"];
    const responsedata = await ConstructorEventGet(ShowStudentName, { mentorId });
    console.log("Full API Response:", responsedata);

    if (Array.isArray(responsedata)) {
      setStudentNameoptions(responsedata);
    } else {
      console.error("Response is not array:", responsedata);
      setStudentNameoptions([]);
    }

  } catch (error) {
    console.error("Error fetching student names:", error);
  }
};

  const studentAdmiration = async () => {
    try {
      const Params = {
        "Userid": studentName,
        "StarRating": starRating.toString(),
      };

      const responsedata = await ConstructorEventPost(StudentAdmiration, Params);
      console.log("Admiration Response:", responsedata);

      navigate('/codomo/admin/createnewuser');

    } catch (error) {
      console.error("Error sending admiration:", error);
    }
  };

  const handleStarClick = (rating) => {
    setStarRating(rating);
  };

  const renderStars = () => {
    const stars = [];
    for (let i = 1; i <= 5; i++) {
      stars.push(
        <span
          key={i}
          onClick={() => handleStarClick(i)}
          style={{ cursor: "pointer" }}
          className={`star ${i <= starRating ? 'star-two' : 'star-one'}`}
        >
          {i <= starRating ? "★" : "☆"}
        </span>
      );
    }
    return stars;
  };

  return (
    <>
      <Header />
      <div className="nav-tab-wrapper tabs section-padding">
        <div className="container">
          <div className="grid grid-cols-12 gap-[30px]">
            <div className="xl:col-span-5 lg:col-span-6 col-span-12">
              <div className="mini-title">Message</div>
              <h4 className="column-title">CODOMO</h4>
              <div>Send Individual Messages to Students</div>
            </div>

            <div className="xl:col-span-7 lg:col-span-6 col-span-12">
              <div className="bg-white shadow-box7 p-8 rounded-md">

                {/* Student Dropdown */}
                <div className="input-container">
                  <div>Student Name</div>

                  <select
                    className="from-control"
                    value={studentName}
                    onChange={(e) => setStudentName(e.target.value)}
                    required
                  >
                    <option value="">Select Student</option>

                    {Array.isArray(studentNameoptions) &&
                      studentNameoptions.map((item, index) => (
                        <option key={index} value={item.user_id}>
                          {item.user_name}
                        </option>
                      ))
                    }
                  </select>
                </div>

                {/* Star Rating */}
                <div className="input-container mt-4">
                  <div>Star Rating*</div>
                  {renderStars()}
                </div>

                <button
                  className="btn btn-primary mt-[10px]"
                  type="button"
                  onClick={studentAdmiration}
                  disabled={!studentName || starRating === 0}
                >
                  Click Me
                </button>

              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default NotificationService;